<!-- 搜商品 -->
<template>
    <div id="goodSearch" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>汽配快搜</el-breadcrumb-item>
                <el-breadcrumb-item>搜商品</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">商品编码:</div>
            <el-input
                    style="width: 180px"
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.GoodCode"
                    placeholder="请输入商品编码">

            </el-input>
            <div class="search-name">商品名称:</div>
            <el-input
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.GoodName"
                    placeholder="请输入商品名称">

            </el-input>
            <div class="search-name">商品类型:</div>
            <div class="search-item goods-categories">
                <el-input
                        size="small"
                        readonly
                        v-model.trim="typeName"
                        @click.stop.native="showCategories()"
                        placeholder="请输选择商品类型">
                </el-input>
                <div class="categories-tree" v-show="categoriesShow">
                    <chooseGoodsType @chooseNode="chooseNode"></chooseGoodsType>
                </div>
            </div>
            <el-button type="primary" size="small" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
        </div>
        <div class="qp-ctn">
            <el-card class="box-card qp-item" v-for="item in tableData" :key="item.Id">
                <div class="qp-cover">
                    <img :src="downUrl+item.MainImg" alt="" :onerror="defaultImg">
                </div>
                <div class="qp-msg">
                    <p>商品名称：{{item.GoodName }}</p>
                    <p>编码：{{item.GoodCode}}</p>
                    <p>价格：{{item.MarketPrice}}</p>
                    <p v-if="item.Inventory != 0">库存：{{item.Inventory}}</p>
                    <p v-else>库存：<span style="color: red">暂无库存</span></p>
                    <p class="ops-ctn">
                        <el-button size="mini" @click="showDialog(3,item)" v-if="permission.编辑">编辑</el-button>
                        <el-button size="mini" @click="showDialog(2,item)" v-if="permission.推送">推送</el-button>
                    </p>
                </div>
            </el-card>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[12, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
        <el-dialog
                :before-close="closeDialog"
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                width="800px"
        >   <div class="dialog-content">
            <template v-if="dialogType==2">
                <push :goodMsg="choosedGood" @closeDialog="closeDialog"></push>
            </template>
            <template v-else-if="dialogType==3">
                <transGood :goodMsg="choosedGood"
                           type="edit"
                           @loadData="loadData"
                           @closeDialog="closeDialog"
                           ref="transGood">
                </transGood>
            </template>
        </div>
        </el-dialog>
    </div>
</template>
<script>
    import chooseGoodsType from '@/components/common/chooseGoodsType.vue'
    import push from '@/components/business/search/push.vue'
    import transGood from '@/components/business/search/transGood.vue'
    export default {
        name: 'goodSearch',
        components: {
            chooseGoodsType,
            push,
            transGood,
        },
        data() {
            return {
                categoriesShow:false,
                defaultImg:'this.src="' + this.$util.DEFAULT_IMAGE + '"',
                downUrl:this.$util.QN_URL_BASE, // 下载
                typeName:'',
                choosedGood:{},
                dialogType:3,
                dialogTitle:'',
                dialogVisible:false, // dialog显隐
                searchData: {
                    GoodCode:'',
                    GoodName: '',
                    CateId: '',
                    page:1, // 当前页数
                    limit:12, // 每页限制条数
                    key:'', //关键字查询
                },
                tableData: [],
                tableDataLength:0,
                permission:{}
            }
        },
        mounted() {
            this.getTableData()
            window.onclick = ()=>{
                this.categoriesShow = false
            }
            this.$util.getPermission('搜商品').then((res)=>{
                this.permission = res
            })
        },
        methods: {
            // 选中商品分类
            chooseNode(data){
                if (data){
                    this.searchData.CateId = data.Item.CateId
                    this.typeName = data.Item.Name
                }
                else {
                    this.searchData.CateId = ''
                    this.typeName = ''
                }
                this.dialogVisible = false
                this.categoriesShow = false
            },
            showCategories(){
                this.categoriesShow = true
            },
            loadData(){
                this.getTableData()
                this.closeDialog()
            },
            closeDialog(){
                if (this.dialogType == 3){
                    this.$refs.transGood.resetFrom()
                }
                this.dialogVisible = false
            },
            showDialog(type,item){
                if (item){
                    this.choosedGood = item
                }
                if(type == 1){
                    this.dialogTitle = '选择商品类型'
                }
                else if (type == 2){
                    if (this.$store.state.connectState != 2){
                        this.$message({
                            message: '请先点击右上方按钮连接客服',
                            type: 'warning'
                        });
                        return
                    }
                    this.dialogTitle = '推送'
                }
                else if (type == 3){
                    this.dialogTitle = '编辑商品'
                }
                this.dialogType = type
                this.dialogVisible = true;
            },
            getTableData(){
                this.axios.get('/ERPGood/LoadGoods',{
                    params: this.searchData
                })
                    .then((response)=> {
                        this.tableData = response.data.data
                        this.tableDataLength = response.data.count
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            resetSearch(){
                this.searchData = {
                    GoodCode:'',
                    GoodName: '',
                    CateId: '',
                    page:1, // 当前页数
                    limit:12, // 每页限制条数
                    key:'', //关键字查询
                }
                this.typeName = ''
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            }
        }
    }
</script>
<style lang="less" scoped>
    .qp-ctn {
        display: flex;
        flex-wrap: wrap;
    }
    .ops-ctn {
        padding-top: 10px;
        display: flex;
        justify-content: flex-end;
    }
    .carType-ctn {
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        min-height: 40px;
        padding: 10px;
        display: flex;
        align-items: center;
    }
    .carTypeItem {
        padding: 0 5px;
        height: 24px;
        line-height: 24px;
        border: 1px solid @theme;
        color: @theme;
        margin-right: 10px;
    }
    .carTypeItem-show {
        display: inline-block;
    }
</style>
<style lang="less">
    .qp-item {
        .el-card__body {
            padding: 0;
        }
    }
</style>
